import React from "react";
import { Box, Typography } from "@mui/material";
import CategoryButton from "../categoryButton/categoryButton";
import { motion, useReducedMotion } from "framer-motion";

function HeaderSection({
  selectedCategory,
  setSelectedCategory,
  categories,
  header,
  description,
  type,
}) {
  const isMainCourses = type === "main";
  const reduceMotion = useReducedMotion();

  return (
    <Box
      sx={{
        width: "100%",
        minWidth: 0,
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 1.5,
        mb: isMainCourses ? 1.5 : 2,
        py: isMainCourses ? { xs: 2, sm: 2.5 } : 0,
        px: { xs: 1, sm: 2 },
        borderRadius: isMainCourses ? "0 0 32px 32px" : 0,
      }}
    >
      {header && (
        <Box component={motion.div}
          initial={isMainCourses && !reduceMotion ? { opacity: 0, y: 14 } : false}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: reduceMotion ? 0 : 0.6, ease: [0.22, 1, 0.36, 1] }}
          sx={{ textAlign: "center", width: "100%", minWidth: 0 }}>
          <Typography sx={{ color: "#b58519", fontSize: "0.68rem", fontWeight: 700, letterSpacing: 2.5, textTransform: "uppercase", mb: 0.5 }}>
            {isMainCourses ? "From our kitchen" : "Explore the menu"}
          </Typography>
          <Typography
            className="responsive_fontsize24"
            sx={{
              fontFamily: "Roboto Serif",
              fontWeight: 700,
              textAlign: "center",
              textTransform: "capitalize",
              color: "#252920",
              letterSpacing: "-0.02em",
              fontSize: { xs: "1.45rem", sm: "1.7rem" },
              mt: { xs: 0, md: isMainCourses ? 0 : 2 },
            }}
          >
            {header}
          </Typography>
          <Typography sx={{ color: "#747767", mt: 0.5, fontSize: "0.9rem" }}>
            {description || (isMainCourses ? "Discover dishes made fresh for your table" : "Choose a category to find your favorite dishes")}
          </Typography>
        </Box>
      )}

      <Box sx={{ width: "100%", minWidth: 0, minHeight: type === "menu" ? { xs: 134, sm: 174, md: 190 } : 0 }}>
      <CategoryButton
        categories={categories}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        type={type} // pass type to CategoryButton
      />
      </Box>
    </Box>
  );
}

export default HeaderSection;
